var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("nav", {
      staticClass:
        "bg-gray-900 pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0",
      staticStyle: { height: "50px" }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "flex flex-col md:flex-row" }, [
      _c(
        "div",
        { staticClass: "main-content flex-1 bg-gray-100 mt-12 md:mt-2" },
        [
          _c(
            "div",
            { staticClass: "bg-blue-800 p-2 shadow text-xl text-white" },
            [
              _c(
                "div",
                { staticClass: "bg-grey-lighter min-h-screen flex flex-col" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "bg-white px-6 py-8 rounded shadow-md text-black w-full"
                        },
                        [
                          _c("img", {
                            staticClass: "m-auto mb-10",
                            staticStyle: { width: "150px" },
                            attrs: {
                              src: require("@/assets/musicverse-logo.png")
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "form",
                            { on: { submit: _vm.submitForgotPassword } },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.input.email,
                                    expression: "input.email"
                                  }
                                ],
                                staticClass:
                                  "block border border-grey-light w-full p-3 rounded mb-4",
                                attrs: {
                                  type: "text",
                                  name: "email",
                                  placeholder: "Email"
                                },
                                domProps: { value: _vm.input.email },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.input,
                                      "email",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _vm.getStatus !== 200
                                ? _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-red-500 text-xs italic text-left"
                                    },
                                    [_vm._v(_vm._s(_vm.getMessage))]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "w-full content-center py-3 rounded bg-blue-400 text-white hover:bg-blue-600 focus:outline-none my-1",
                                  attrs: {
                                    type: "submit",
                                    disabled: _vm.isLoading
                                  },
                                  on: { click: _vm.submitForgotPassword }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.labelForgotPassword)
                                  ),
                                  _vm.isLoading
                                    ? _c("img", {
                                        staticClass: "m-auto",
                                        attrs: {
                                          src: require("@/assets/bars.svg"),
                                          width: "30px"
                                        }
                                      })
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "text-xs italic text-left mt-5"
                                },
                                [
                                  _vm._v(
                                    "After submit, please check email for forgot password"
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.isEmailHasBeenSend
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "fixed bottom-0 right-0 m-8 w-5/6 md:w-full max-w-sm",
                                  on: {
                                    click: function($event) {
                                      return _vm.toggleToast()
                                    }
                                  }
                                },
                                [
                                  _c("input", {
                                    staticClass: "hidden",
                                    attrs: {
                                      type: "checkbox",
                                      id: "footertoast"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "close cursor-pointer flex items-start justify-between w-full p-2  bg-green-500 h-24 rounded shadow-lg text-white",
                                      attrs: {
                                        title: "close",
                                        for: "footertoast"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Email has been sent\n\n                  "
                                      ),
                                      _c(
                                        "svg",
                                        {
                                          staticClass:
                                            "fill-current text-white",
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 18 18"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01266098", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01266098","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ForgotPassword.vue
// module id = null
// module chunks = 